module.exports = __webpack_public_path__ + "static/media/card-empty.4070368b.svg";